<!-- 话题详情 -->
<template>
    <div class="topicDetails" v-if="init">
        <div class="baseInfo">
            <div class="placeholder"></div>
            <div class="baseInfoContent">
                <div class="logoNameCount">
                    <img :src="topicBaseInfo.logourl" class="logourl" alt="">
                    <div class="nameCount">
                        <div class="name">{{topicBaseInfo.name}}</div>
                        <div class="count">
                            <span class="countItem">今日阅读{{changeTodayviewcount}}</span>
                            <span class="vertical">|</span>
                            <span class="countItem">今日讨论{{changeTodaydiscusscount}}</span>
                        </div>
                    </div>
                </div>
                <div class="summary">{{topicBaseInfo.summary}}</div>
                <div class="handleBox">
                    <div class="handleItem join" @click="handleOpenAppTips">参与话题</div>
                    <div class="handleItem share" @click="handleOpenAppTips">分享话题</div>
                    <div class="handleItem attention" @click="handleOpenAppTips">关注话题</div>
                </div>
            </div>
        </div>
        <van-list v-model="loading" :finished="finished" :finished-text="topicDiaryList.length ? '没有更多了' : ''" @load="onLoad">
            <div class="noData" v-if="!topicDiaryList.length">
                <img :src="require('@/common/images/mobile/img-noData.png')" class="noDataImg" alt="">
                <p class="tips">暂无讨论</p>
            </div>
            <div class="listBox" v-else>
                <div class="item" v-for="(item, index) in topicDiaryList" :key="index">
                    <div class="userMsg">
                        <img :src="item.customerlogo" class="customerLogo" alt="">
                        <div class="nameMsg">
                            <div class="nameAttention">
                                <div class="name">{{item.customername}}</div>
                                <div class="attention" @click="handleOpenAppTips">关注</div>
                            </div>
                            <div class="dutyCompanyName">
                                <span class="nameItem">{{item.dutyname}}</span>
                                <span class="vertical">|</span>
                                <span class="nameItem">{{item.companyname}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="itemContent">
                        <pre v-html="item.content"></pre>
                    </div>
                    <div class="handleBox">
                        <div class="handleItem" @click="handleOpenAppTips">
                            <img :src="require('@/common/images/mobile/comment_icon.png')" class="icon" alt="">
                            <div class="value">{{item.commentcount ? item.commentcount : '评论'}}</div>
                        </div>
                        <div class="handleItem" @click="handleOpenAppTips">
                            <img :src="require('@/common/images/mobile/like_icon.png')" class="icon" alt="">
                            <div class="value">{{item.praisecount ? item.praisecount : '点赞'}}</div>
                        </div>
                        <div class="handleItem" @click="handleOpenAppTips">
                            <img :src="require('@/common/images/mobile/collect_icon.png')" class="icon" alt="">
                            <div class="value">{{item.favoritecount ? item.favoritecount : '收藏'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
        
        <div class="bottomBtnBox">
            <a class="bottomBtn" @click="handleClickOpenApp" id="openAppATags" v-if="mobilePhoneType === 'iOS' || mobilePhoneType === 'wechat-iOS'" :href="'https://www.capwhale.com/ulink/iosdmapp/index/vtopicInfo/vtopicInfo?code=' + params.code">打开App进行更多操作</a>
            <a class="bottomBtn" @click="handleClickOpenApp" id="openAppATags" v-if="mobilePhoneType === 'android' || mobilePhoneType === 'wechat-android'" :href="'dmapp://index/vtopicInfo/vtopicInfo?code=' + params.code">打开App进行更多操作</a>
            <div class="wechatOpenApp" v-if="_isWixin() && mobilePhoneType === 'android'">
                <wx-open-launch-app id="launch-btn" appid="wx04d8952d30352373" @error="handlewxOpenApperror"
                    :extinfo="'dmapp://index/vtopicInfo/vtopicInfo?code=' + params.code"
                    style="position:absolute;top:0;right:0;width: 100%;height: 0.9rem;zIndex: 1000;display: flex;alignItems: center;justifyConent: center">
                    <script type="text/wxtag-template">
                        <style>.btn { padding: 500px;color: transparent;text-align: center;background: transparent;border: none;display: block;}</style>
                        <button class="btn">立即打开</button>
                    </script>
                </wx-open-launch-app>
            </div>
        </div>
    </div>
</template>

<script>
import {getVTopicBaseInfo, getVTopicDiaryList} from 'api/api.js'
import { mapActions } from 'vuex'
import { changeTenThousand, examineMobilePhoneType } from 'common/js/tools.js'
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
export default {
    data() {
        return {
            topicBaseInfo: {
                todayviewcount: 0,
                todaydiscusscount: 0
            },
            init: false,
            loading: false,
            finished: false,
            params: {
                code: '',
                apptype: ''
            },
            topicDiaryParams: {
                page: 0,
                pagesize: 10,
                condition: {
                    topiccode: '',
                    apptype: ''
                }
            },
            total: 0,
            topicDiaryList: [],
            mobilePhoneType: examineMobilePhoneType()
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.code && this.$route.query.apptype) {
            this.params.code = this.$route.query.code
            this.topicDiaryParams.condition.topiccode = this.$route.query.code
            this.topicDiaryParams.condition.apptype = this.$route.query.apptype
            this.params.apptype = this.$route.query.apptype
            this.getVTopicBaseInfo()
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        document.title = '话题详情'
    },
    methods: {
        getVTopicBaseInfo() {
            this.setLoading(true)
            getVTopicBaseInfo({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    this.init = true
                    this.topicBaseInfo = res.data
                    if (this._isWixin()) {
                        let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?code=' + this.$route.query.code
                        getWXSDKSetting({
                            title: this.topicBaseInfo.name,
                            desc: '',
                            link: link,
                            imgUrl: '',
                        })
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        onLoad() {
            this.topicDiaryParams.page++
            this.getVTopicDiaryList()
        },
        formatContent(content) {
            let str = content.replace(/\n/g, '<br/>')
            let tags = str.match(/#[^#]*#/g);
            if (tags) {
                let arr = []
                tags.map(item => {
                    if (!arr.includes(item)) {
                        arr.push(item)
                        let reg = "/" + item + "/g";
                        let myregex = eval(reg);//转换为正则对象
                        str=str.replace(myregex,"<a style='color: #74CEFF' class='tags'>"+item+"</a>")
                    }
                })
            }
            return str
        },
        getVTopicDiaryList() {
            this.setLoading(true)
            getVTopicDiaryList({
                data: Object.assign({}, this.topicDiaryParams),
                success: res => {
                    this.loading = false
                    this.setLoading(false)
                    this.total = res.pageableData.rowCount
                    res.data.forEach(item => {
                        item.content = this.formatContent(item.content)
                    })
                    if (this.topicDiaryParams.page === 1) {
                        this.topicDiaryList = res.data
                    } else {
                        this.topicDiaryList = this.topicDiaryList.concat(res.data)
                    }
                    if (this.topicDiaryList.length >= this.total) {
                        this.finished = true
                    } else {
                        this.finished = false
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        handleOpenAppTips() {
            this.$dialog.alert({
                title: '提示',
                message: '打开App进行更多操作',
            }).then(() => {
                document.getElementById('openAppATags').click()
            })
        },
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        handlewxOpenApperror(e) {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?code=' + this.$route.query.code + '&apptype=' + this.$route.query.apptype
            if (e.detail.errMsg === 'launch:fail') { // 未安装APP
                if (this.mobilePhoneType === 'iOS') {
                    window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                } else {
                    window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                }
            } else if (e.detail.errMsg === 'launch:fail_check fail') { // appid未绑定未关联到微信
                if (this.mobilePhoneType === 'iOS') {
                    window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                } else {
                    window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                }
            }
        },
        handleClickOpenApp() {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?code=' + this.$route.query.code + '&apptype=' + this.$route.query.apptype
            setTimeout(() => {
                if (this.mobilePhoneType === 'iOS') {
                    window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                } else {
                    window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                }
            }, 2000)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        changeTodayviewcount() {
            return changeTenThousand(this.topicBaseInfo.todayviewcount)
        },
        changeTodaydiscusscount() {
            return changeTenThousand(this.topicBaseInfo.todaydiscusscount)
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.topicDetails {
    height: 100vh;
    overflow: scroll;
    background: #FAFAFA;
    padding-bottom: 1rem;
    box-sizing: border-box;
    .baseInfo {
        .placeholder {
            height: 2rem;
            background: #1C2A50;
        }
        .baseInfoContent {
            background: #fff;
            border-radius: 0.2rem;
            padding: 0 0.3rem 0.3rem;
            .logoNameCount {
                display: flex;
                align-items: center;
                background: transparent;
                position: relative;
                top: -0.8rem;
                margin-bottom: 0.24rem;
                .logourl {
                    width: 1.4rem;
                    height: 1.4rem;
                    border-radius: 0.1rem;
                    margin-right: 0.3rem;
                }
                .nameCount {
                    flex: 1;
                    width: 0;
                    height: 1.4rem;
                    padding: 0.14rem 0;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .name {
                        font-size: 0.32rem;
                        color: #fff;
                        line-height: 0.38rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .count {
                        font-size: 0.28rem;
                        color: #999999;
                        line-height: 0.34rem;
                        .vertical {
                            margin: 0 0.2rem;
                        }
                    }
                }
            }
            .summary {
                margin-top: -0.8rem;
                font-size: 0.26rem;
                color: #666666;
                line-height: 0.4rem;
                margin-bottom: 0.3rem;
            }
            .handleBox {
                display: flex;
                justify-content: space-around;
                .handleItem {
                    width: 1.36rem;
                    height: 0.44rem;
                    border-radius: 0.05rem;
                    color: #fff;
                    text-align: center;
                    line-height: 0.44rem;
                    font-size: 0.24rem;
                    &.join {
                        background: #74CEFF;
                    }
                    &.share {
                        background: #FF8D20;
                    }
                    &.attention {
                        background: #F24945;
                    }
                }
            }
        }
    }
    .van-list {
        .noData {
            background: #fff;
            text-align: center;
            padding: 0.6rem 0;
            .noDataImg {
                width: 1.69rem;
                height: 1.63rem;
                margin: auto;
            }
            .tips {
                margin-top: 0.24rem;
                color: #ccc;
            }
        }
        .listBox {
            .item {
                margin: 0.2rem 0.3rem;
                background: #fff;
                padding: 0.3rem 0.3rem 0.2rem;
                box-shadow: 0px 0.02rem 0.18rem 0px rgba(188,188,188,0.25);
                border-radius: 0.2rem;
                .userMsg {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.2rem;
                    .customerLogo {
                        width: 0.98rem;
                        height: 0.98rem;
                        border-radius: 0.1rem;
                        margin-right: 0.3rem;
                    }
                    .nameMsg {
                        flex: 1;
                        width: 0;
                        height: 0.98rem;
                        padding: 0 0 0.05rem;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .nameAttention {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .name {
                                font-size: 0.28rem;
                                color: #333333;
                                line-height: 0.34rem;
                            }
                            .attention {
                                width: 0.88rem;
                                height: 0.44rem;
                                border-radius: 0.05rem;
                                background: #F24945;
                                color: #fff;
                                font-size: 0.24rem;
                                text-align: center;
                                line-height: 0.44rem;
                            }
                        }
                        .dutyCompanyName {
                            font-size: 0.24rem;
                            color: #999999;
                            line-height: 0.28rem;
                            .vertical {
                                margin: 0 0.2rem;
                            }
                        }
                    }
                }
                .itemContent {
                    pre {
                        font-size: 0.26rem;
                        color: #666666;
                        line-height: 0.4rem;
                        white-space: pre-wrap;
                    }
                }
                .handleBox {
                    margin-top: 0.5rem;
                    display: flex;
                    justify-content: flex-end;
                    .handleItem {
                        display: flex;
                        align-items: center;
                        &:not(:last-of-type) {
                            margin-right: 0.3rem;
                        }
                        .icon {
                            width: 0.26rem;
                            height: 0.27rem;
                        }
                        .value {
                            margin-left: 0.1rem;
                            font-size: 0.24rem;
                            color: #999999;
                        }
                    }
                }
            }
        }
    }
    .bottomBtnBox {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.88rem;
        .bottomBtn {
            height: 0.88rem;
            color: #fff;
            text-align: center;
            line-height: 0.88rem;
            background: #FF8D20;
            font-size: 0.28rem;
            display: block;
        }
        .wechatOpenApp {
            height: 0.88rem;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            overflow: hidden;
        }
    }
}
</style>